module.exports = __webpack_public_path__ + "static/media/bj.03e408ac.svg";